import { combineReducers } from 'redux';
import feed from './feed';
import primarySpotId from './primarySpotId';
import subregionId from './subregionId';
import overview from './overview';
import nearby from './nearby';

export default combineReducers({
  feed,
  primarySpotId,
  subregionId,
  overview,
  nearby,
});
